const images_base_url = "https://localhost:3000";
const images_base_url1 = "https://www.queenstownservicedapartments.co.nz/";

const bookingLink = "https://www.mybookingsite.io/#roomtype?propertyId=9909";

export { images_base_url, images_base_url1, bookingLink };